import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { CopySourceAdapter, commonCopySourceAdapts } from 'app/model/adapters/activities/copysource/copysource.adapter';
import { ValueAdapter } from 'app/model/adapters/value.adapter';
import { Metamodel } from 'app/model/base/model';
import { Model } from 'app/model/backendmodel';
import { CopyActivity } from 'app/model/pipeline/copy.activity';
import { AttioCopySource } from 'app/model/pipeline/copysource/attio.copysource';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(AttioCopySource),
    asynchronous: true,
    adapts: {
        ...commonCopySourceAdapts,
        pageSize: '*'
    }
})
export class AttioCopySourceAdapter extends CopySourceAdapter<AttioCopySource, Model.AttioSource> {
    protected override async _toResource(copySource: AttioCopySource): Promise<Model.AttioSource> {
        const resource = this._toTabularResource(
            copySource,
            Metamodel.modelFor(AttioCopySource).name
        ) as Model.AttioSource;
        resource.pageSize = ValueAdapter.toResource(copySource, AttioCopySource.PAGE_SIZE);
        return resource;
    }

    protected override async _toModel(
        resource: Model.AttioSource,
        copyActivity: CopyActivity
    ): Promise<AttioCopySource> {
        const copySource = this._toTabularModel(
            resource,
            copyActivity,
            AttioCopySource.MODEL
        ) as AttioCopySource;
        ValueAdapter.toModel(copySource, AttioCopySource.PAGE_SIZE, resource.pageSize);
        return copySource;
    }
}
